import { render } from "./BookingFooter.vue?vue&type=template&id=7e998c4a"
import script from "./BookingFooter.vue?vue&type=script&lang=js"
export * from "./BookingFooter.vue?vue&type=script&lang=js"

import "./BookingFooter.vue?vue&type=style&index=0&id=7e998c4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__